import React from "react";
import {
  Input,
  FormLabel,
  Textarea,
  Flex,
  Select,
  Box,
} from "@chakra-ui/react";

const General = ({ formHandler }) => {
  return (
    <div>
      <p>Program Settings</p>
      <Box mt={4}>
        <FormLabel htmlFor="title">Program Title</FormLabel>
        <Input
          variant="filled"
          id="title"
          type="text"
          name="title"
          placeholder="Enter Title"
          size="lg"
          onChange={formHandler.handleChange}
          value={formHandler.values.title}
          isRequired
        />
      </Box>
      <Box mt={4}>
        <FormLabel htmlFor="learn">What you’ll learn</FormLabel>
        <Textarea
          placeholder="What you’ll learn"
          type="text"
          variant="filled"
          size="sm"
          id="summary"
          name="summary"
          onChange={formHandler.handleChange}
          value={formHandler.values.summary}
          isRequired
        />
      </Box>
      <Box mt={4}>
        <Flex justifyContent="space-between">
          <Box w="48%">
            <FormLabel htmlFor="learn">Subscription Price (₦)</FormLabel>
            <Input
              placeholder="Enter Price"
              variant="filled"
              size="lg"
              id="price"
              type="number"
              name="price"
              min="0"
              onChange={formHandler.handleChange}
              value={formHandler.values.price}
              isRequired
            />
          </Box>
          <Box w="48%">
            <FormLabel htmlFor="learn">Program Duration (weeks)</FormLabel>
            <Input
              placeholder="Enter duration in weeks"
              variant="filled"
              size="lg"
              id="duration"
              type="number"
              min="0"
              max="4"
              name="duration"
              onChange={formHandler.handleChange}
              value={formHandler.values.duration}
              isRequired
            />
          </Box>
        </Flex>
      </Box>
      <Flex mt={7} justifyContent="space-between">
        <Select
          size="lg"
          id="instructor"
          min="0"
          max="4"
          name="instructor"
          onChange={formHandler.handleChange}
          value={formHandler.values.instructor}
          isRequired
          placeholder="Instructor"
          w="48%"
        >
          <option value="option1">Option 1</option>
          <option value="option2">Option 2</option>
          <option value="option3">Option 3</option>
        </Select>
        <Select
          size="lg"
          id="docFormat"
          min="0"
          max="4"
          name="docFormat"
          onChange={formHandler.handleChange}
          value={formHandler.values.docFormat}
          isRequired
          placeholder="Document format"
          w="48%"
        >
          <option value="PDF">PDF</option>
          <option value="PowerPoint (.ppx)">PowerPoint (.ppx)</option>
          <option value="Word Document (.doc, .docx)">
            Word Document (.doc, .docx)
          </option>
          <option value="Excel (.xls)">Excel (.xls)</option>
          <option value="Webpage (.html)">Webpage (.html)</option>
        </Select>
      </Flex>
    </div>
  );
};

export default General;
